"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_CONSTANTS = exports.DEFAULT_COOKIE_OPTIONS = exports.ROUTE_COOKIE_KEY = exports.LANGUAGE_COOKIE_KEY = exports.NOOM_WEB_DOMAIN = void 0;
exports.NOOM_WEB_DOMAIN = 'https://web.noom.com';
exports.LANGUAGE_COOKIE_KEY = 'noom_lang';
exports.ROUTE_COOKIE_KEY = 'noom_route_id';
exports.DEFAULT_COOKIE_OPTIONS = {
    path: '/',
    // 10 years from now
    expires: new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1000),
};
var ROUTE_CONSTANTS;
(function (ROUTE_CONSTANTS) {
    ROUTE_CONSTANTS["affiliateNoTrial"] = "aff-ntrl";
    ROUTE_CONSTANTS["affiliateNoTrialPromo"] = "aff-ntrl-prm";
    ROUTE_CONSTANTS["affiliateTrialNPB"] = "affiliate-trial-npb";
    ROUTE_CONSTANTS["app14DayFtWeb"] = "app-14-day-ft-web";
    ROUTE_CONSTANTS["app14DayReturning"] = "app-14-day-returning";
    ROUTE_CONSTANTS["app14DayMain"] = "app-14-day-main";
    ROUTE_CONSTANTS["app14DayWebMain"] = "app-14-day-web-main";
    ROUTE_CONSTANTS["appEmail"] = "app-email";
    ROUTE_CONSTANTS["awsem"] = "awsem";
    ROUTE_CONSTANTS["baseline"] = "_baseline";
    ROUTE_CONSTANTS["dietary"] = "dietary";
    ROUTE_CONSTANTS["direct"] = "_direct";
    ROUTE_CONSTANTS["emailMain"] = "email-main";
    ROUTE_CONSTANTS["emailWinback"] = "email-winback";
    ROUTE_CONSTANTS["exsf01"] = "exsf01";
    ROUTE_CONSTANTS["exsf01d"] = "exsf01d";
    ROUTE_CONSTANTS["hmAwsem"] = "hm-awsem";
    ROUTE_CONSTANTS["hmDirect"] = "hm-direct";
    ROUTE_CONSTANTS["hmEmail"] = "hm-email";
    ROUTE_CONSTANTS["hmExsf01"] = "hm-exsf01";
    ROUTE_CONSTANTS["hmExsf01d"] = "hm-exsf01d";
    ROUTE_CONSTANTS["hmPaid"] = "hm-paid";
    ROUTE_CONSTANTS["hmWinback"] = "hm-winback";
    ROUTE_CONSTANTS["hmReferrals"] = "hm-referrals";
    ROUTE_CONSTANTS["ndpp"] = "ndpp";
    ROUTE_CONSTANTS["referrals"] = "referrals";
    ROUTE_CONSTANTS["supporters"] = "supporters";
    ROUTE_CONSTANTS["winback"] = "winback";
    // Added 7/7/21 from https://github.com/noom/growth/blob/552da1633e9f8689d849597cc8dc0b04ffbb7872/growth/flow/flows/en.py#L425
    ROUTE_CONSTANTS["control"] = "_control";
    ROUTE_CONSTANTS["experiment"] = "_experiment";
    ROUTE_CONSTANTS["phillips"] = "philips-airfryer";
    ROUTE_CONSTANTS["humana"] = "humana";
    ROUTE_CONSTANTS["affiliate"] = "affiliate-trial";
    ROUTE_CONSTANTS["freeTrial"] = "exft";
    ROUTE_CONSTANTS["appUpsell"] = "app-upsell";
    ROUTE_CONSTANTS["appEmployerSurvey"] = "app-employer";
    ROUTE_CONSTANTS["clinical"] = "clinical";
    ROUTE_CONSTANTS["coachReferrals"] = "coach-referrals";
})(ROUTE_CONSTANTS = exports.ROUTE_CONSTANTS || (exports.ROUTE_CONSTANTS = {}));
//# sourceMappingURL=constants.js.map